import { ApiTicket } from '../types';
import { detectTicketContext } from './ticketContextDetector';

const COI_CATEGORY_MAPPING = {
  'among-employees': 'Relationships',
  'with-customers': 'Relationships',
  'with-competitors': 'Relationships',
  government: 'Relationships',
  advisory: 'Outside Employment',
  'outside-employment': 'Outside Employment',
  'personal-investment': 'Personal Investment',
} as const;

export function analyzeFormFromTicket(apiTicket: ApiTicket): {
  formType:
    | 'conflict-of-interest'
    | 'gifts-and-donations'
    | 'other-compliance-matters'
    | 'employee-movement'
    | 'unknown';
  category?: string;
  subcategory?: string;
} {
  const formTypeSlug = apiTicket.formType.slug;

  if (formTypeSlug === 'conflict-of-interest') {
    try {
      const answers =
        apiTicket.answers?.map(answer => ({
          question: {
            questionTranslationKey: answer.question.questionTranslationKey,
          },
          answer: answer.answer,
          selectedOption: answer.selectedOption,
        })) || [];

      if (answers.length > 0) {
        const context = detectTicketContext(answers);
        return {
          formType: 'conflict-of-interest' as const,
          category: context.category,
          subcategory: context.subcategory,
        };
      }
    } catch (error) {
      console.warn('Failed to detect Conflict of Interest context:', error);
    }

    return {
      formType: 'conflict-of-interest' as const,
      category: 'Unknown',
      subcategory: undefined,
    };
  }

  if (formTypeSlug === 'gifts-and-donations') {
    try {
      const answers =
        apiTicket.answers?.map(answer => ({
          question: {
            questionTranslationKey: answer.question.questionTranslationKey,
          },
          answer: answer.answer,
          selectedOption: answer.selectedOption,
        })) || [];

      if (answers.length > 0) {
        const context = detectTicketContext(answers);
        return {
          formType: 'gifts-and-donations' as const,
          category: context.category,
          subcategory: context.subcategory,
        };
      }
    } catch (error) {
      console.warn('Failed to detect G&D context:', error);
    }

    return {
      formType: 'gifts-and-donations' as const,
      category: 'Unknown',
      subcategory: undefined,
    };
  }

  if (formTypeSlug === 'other-compliance-matters') {
    try {
      const answers =
        apiTicket.answers?.map(answer => ({
          question: {
            questionTranslationKey: answer.question.questionTranslationKey,
          },
          answer: answer.answer,
          selectedOption: answer.selectedOption,
        })) || [];

      if (answers.length > 0) {
        const context = detectTicketContext(answers);
        return {
          formType: 'other-compliance-matters' as const,
          category: context.category,
          subcategory: context.subcategory,
        };
      }
    } catch (error) {
      console.warn('Failed to detect Other Compliance Matters context:', error);
    }

    return {
      formType: 'other-compliance-matters' as const,
      category: undefined,
      subcategory: undefined,
    };
  }

  if (formTypeSlug === 'employee-movement') {
    try {
      const answers =
        apiTicket.answers?.map(answer => ({
          question: {
            questionTranslationKey: answer.question.questionTranslationKey,
          },
          answer: answer.answer,
          selectedOption: answer.selectedOption,
        })) || [];

      if (answers.length > 0) {
        const context = detectTicketContext(answers);
        return {
          formType: 'employee-movement' as const,
          category: context.category,
          subcategory: context.subcategory,
        };
      }
    } catch (error) {
      console.warn('Failed to detect Employee Movement context:', error);
    }

    return {
      formType: 'employee-movement' as const,
      category: 'Unknown',
      subcategory: undefined,
    };
  }

  return {
    formType: 'unknown' as const,
    category: undefined,
    subcategory: undefined,
  };
}

export function getCategoryDisplayName(category: string): string {
  return category;
}

export function getSubcategoryDisplayName(subcategory: string): string {
  return subcategory;
}
